import { Link } from 'react-router-dom';
import styles from './styles.module.scss';
import Button from './Button';
import Slider from './Slider';
import Modal from './Modal';
import { useState } from 'react';
import ReactGA from "react-ga4";
// Ensure dataLayer exists on the global window object

ReactGA.initialize("G-HYJDMRTYFP");
ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  
const GamePane = (props) => {
  const gameLinks = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    `https://nevrycards.itch.io/creepypast`
  ]


  const purchaseIds = [8]
const [modal,setModal] = useState(null);
const [sliderIndex,setSliderIndex] = useState(1);
    let difficultyStars = [];
    for(let i = 0; i < props.gameData.difficulty ; i++){
        difficultyStars.push(<div className={`${styles.gamePaneDifficultyStar}`}></div>);
    }

      function download(fileUrl, fileName) {
    var a = document.createElement("a");
    a.href = fileUrl;
    a.setAttribute("download", fileName);
    a.click();
  }
 


  const downloadGame = (e) => {
    console.log(props.gameData.download);
    download(`/downloadable/${props.gameData.download}.ZIP`,`${props.gameData.download}.ZIP`);
    
    

      ReactGA.event(`Download ${props.gameData.download}`, {
        'event_category': 'ZIP',
        'event_label': `/downloadable/${props.gameData.download}.ZIP`
      });
    
   
  }

  const playGame = (e) => {

    
   
      ReactGA.event(`Play ${props.gameData.name}`, {
        'event_category': 'PLAY',
        'event_label': `${props.gameData.name}`
      });
    
   
  }
  const switchDesc = (sw) => {
    const desc = document.querySelectorAll('.desc');

    desc.forEach((e,i)=>{
      e.textContent = props.gameData.slideDescriptions[sw];
    });
 
  }
  const setSliderIdx = (idx) =>{
    setSliderIndex(idx);
  }
  const openModalDesc = (idx) => {
    let data = <Slider currentIndex={sliderIndex} switch={switchDesc} set={setSliderIdx} gameData={props.gameData}></Slider>;
    
    setModal(<div className={`${styles.sliderDesc}`}>{data}
    <div className={`desc ${styles.gamePaneDescription}`}>{props.gameData.slideDescriptions[sliderIndex - 1]}</div>
    </div>);
    
  }

  const openModal = (e) => {
  let data = '';
  switch(props.gameData.id){
    case 1:
        data = <div className={styles.newsChanges}>

             <h1 className='white'>
          Re|Rattled Update #2
       </h1>
       <h2 className='white'>
        Design Changes
      </h2>
      <ul className='white'>
        <li className="li-pf"> 
          You can continue to Chapter 6 after bad ending.
        </li>
        <li className="li-pf"> 
          Tier based weapons now have level requirements.
        </li>      
      </ul>
        
          <hr/>

           <h1 className='white'>
          Re|Rattled Major-Update #1
       </h1>
       <h2 className='white'>
        Design Changes
      </h2>
      <ul className='white'>
        <li className="li-pf"> 
          Battles system improved
        </li>
        <li className="li-pf"> 
          Battle-Equipment menu simplified
        </li>      
      </ul>
        
          <hr/>


        <h1 className='white'>
          Version 1.5
       </h1>
       <h2 className='white'>
        Design Changes
      </h2>
      <ul className='white'>
        <li className="li-pf"> 
          Fog filled with shiny particles is a part of atmosphere now
        </li>
        <li className="li-pf"> 
          Battle enemies and battlebacks are animated now
        </li>
        <li className="li-pf"> 
          Skull image appears on bosses HP bar
        </li>
      </ul>
        
          <hr/>
        <h1 className='white'>
          Version 1.43
       </h1>
       <h2 className='white'>
        Bug Fixes
      </h2>
      <ul className='white'>
        <li className="li-pf"> 
       Fisoret's purple crystal doesn't skip him turn
            </li>
            <li className="li-pf"> 
              Rattle Over Time doesn't show text after usage
                   </li>
      </ul>
       <hr/>
        <h1 className='white'>
          Version 1.42
       </h1>
       <h2 className='white'>
        Bug Fixes
      </h2>
      <ul className='white'>
        <li className="li-pf"> 
       Fisoret Battle Requires less turns to defeat him after destroying his crystals
            </li>
      </ul>
       <hr/>
        <h1 className='white'>
          Version 1.4
       </h1>
       <h2 className='white'>
        XMASS Event
      </h2>
      <ul className='white'>
        <li className="li-pf"> 
          Behold the christmass Event !!!
            </li>
            <li className="li-pf"> 
              Characters are suited in xmass costumes
                </li>
                <li className="li-pf"> 
                 Killergarten location is decorated and full of presents
                    </li>
                    <li className="li-pf"> 
                      Even opponents feel the wonderful atmosphere and transformed to fit in
                         </li>
                         <li className="li-pf"> 
                          Help Santa and play new interactive minigames
                             </li>
                             <li className="li-pf"> 
                              This and more in the Xmass night at Killergarten
                                 </li>
          </ul>
        <hr/>
        <h1 className='white'>
          Version 1.37
       </h1>
       <h2 className='white'>
        Bug Fixes
      </h2>
      <ul className='white'>
        <li className="li-pf"> 
           Stat enhancements could be equipped,
           just as they should now.
            </li>
          
          </ul>
        <hr/>
        <h1 className='white'>
          Version 1.36
       </h1>
       <h2 className='white'>
        Design Changes
      </h2>
      <ul className='white'>
        <li className="li-pf"> 
            Toy Car Voucher allows now to buy
            Toy Car from shop directly and works
            with each of them.
            </li>
          
          </ul>
        <hr/>
        <h1 className='white'>
          Version 1.35
       </h1>
       <h2 className='white'>
        Design Changes
      </h2>
      <ul className='white'>
        <li className="li-pf"> 
            Autosave option is available now.
            </li>
          
          </ul>
          <h2 className='white'>
              Balance Changes
          </h2>
          <ul className='white'>
            <li className="li-pf"> 
                Super bosses HP got lowered to
                reasonable values.
                </li>
              
              </ul>
        <hr/>
        <h1 className='white'>
          Version 1.3
       </h1>
       <h2 className='white'>
        Design Changes
      </h2>
      <ul className='white'>
          <li className="li-pf"> 
          Graphics of characters got
          changed, same for the recruitment
          pictures
              </li>
              
                  <li className="li-pf"> 
                   Cameras got weaken and
                   playroom is now easier
                       </li>
            </ul>
       <h2 className='white'>
        New Content
      </h2>
      <ul className='white'>
          <li className="li-pf"> 
          5 New powerfull bosses have
          been added to the game
              </li>
              <li className="li-pf"> 
              Plenty of new droppable
              items have been added to the game
              </li>
             
                   
            </ul>
       
      
      <hr/>
        <h1 className='white'>
          Version 1.19.99
       </h1>
       <h2 className='white'>
        Balance Changes
      </h2>
      <ul className='white'>
          <li className="li-pf"> 
           Stat upgrades are replaced with
           stat accesories now.
              </li>
              <li className="li-pf"> 
               Egg team attacks the same turn
               they ressurect allies now.
              </li>
             
                   
            </ul>
       
      
      <hr/>
        <h1 className='white'>
          Version 1.19.9
       </h1>
       <h2 className='white'>
        Design Changes
      </h2>
      <ul className='white'>
          <li className="li-pf"> 
           Save menu has changed
              </li>
              <li className="li-pf"> 
                Stat menu has changed
                   </li>
                   <li className="li-pf"> 
                    Recruitment pictures got changed
                       </li>
              
                  <li className="li-pf"> 
              Title screen background shows now the 
              amount of party members
                       </li>
                       
                  <li className="li-pf"> 
                    Face Pictures for main team 
                    got changed
                             </li>
            </ul>
       
      
      <hr/>
        <h1 className='white'>
          Version 1.19.5  Final-Mix Halloween
       </h1>
       <h2 className='white'>
        Design Changes
      </h2>
      <ul className='white'>
          <li className="li-pf"> 
            New recolored versions of enemies
            appear in blue, red and Purple
            tier I dungeon instead of standard
              </li>
              
                  <li className="li-pf"> 
                   Poof's Regeneration appears
                   as passive ability now.
                       </li>
            </ul>
       
       <h2 className='white'>
        Bug Fixes
      </h2>  <ul className='white'>
        <li className="li-pf"> 
          Red Slider dungeon I doesn't
          skip one wave of enemies now
            </li>
            <li className="li-pf"> 
              Rattle Over time skips
              enemy turns always, even
              while used 2 turns in a row
                 </li>
            <li className="li-pf"> 
             Password tickets now show
             their availabiliy correctly.
                </li>
          </ul>
      <hr/>
        <h1 className='white'>
          Version 1.19 Final-Mix Halloween
       </h1>
       <h2 className='white'>
       !!EVENT!!
      </h2>
      <ul className='white'>
        <li className="li-pf"> 
          Be ready for killergarten adventure
          in halloween setting, be ready to trick
          and treat your opponents, taking all their
          sweets and exp, discover new exceptionaly
          hard location and yet another super boss
          waiting there to be beaten.
            </li>
          </ul>
       <h2 className='white'>
        Design Changes
      </h2>
      <ul className='white'>
          <li className="li-pf"> 
            Sonia's room is easier to be found now,
            the same is for her paradox selves
              </li>
            </ul>
            <h2 className='white'>
              Balance Changes
            </h2>
            <ul className='white'>
                <li className="li-pf"> 
                Sonia's Doom of Afterlife and Ghost Gatling abilities
                now have dmg limit cap.
                    </li>
                    <li className="li-pf"> 
                     Training ability gives 50 TP instead of 20 now.
                          </li>
                          <li className="li-pf"> 
                           Cubus combo skills deal more damage now.
                                 </li>
                                 <li className="li-pf"> 
                                 Using toys give characters 20 TP instead of 10 now.
                                        </li>
                  </ul>
        <hr/>
        <h1 className='white'>
          Version 1.18 Final-Mix
       </h1>
       <h2 className='white'>
          Design Changes
        </h2>
        <ul className='white'>
            <li className="li-pf"> 
               Save Screen appears after prologue,
               as well as picture explaining controls
               in general.
                </li>
                <li className="li-pf"> 
               Character faces are being displayed without names
               on their photos during the battle
                   </li>
                   <li className="li-pf"> 
                    Information how to stop hiding displays temporarly
                    now, then skips itself
                        </li>
                </ul>
                <h2 className='white'>
                  Balance Changes
                </h2>
                <ul className='white'>
                  <li className="li-pf"> 
                   Cubus Omega Fist ability is less likely to
                   one punch bosses
                      </li>
                      <li className="li-pf"> 
                        Cubus's TP at the start of battle can't exceed
                        50
                           </li>
                           <li className="li-pf"> 
                            Using capcake's Toys give 10 TP to it's users
                               </li>
                               <li className="li-pf"> 
                                Slider dungeon bosses are more difficult now
                                   </li>
                      </ul>
       <hr/>
          <h1 className='white'>
              Version 1.17 Final-Mix
           </h1>
           <h2 className='white'>
              Design Changes
            </h2>
            <ul className='white'>
                <li className="li-pf"> 
                   Sonia's ghost gatling ability now works 100%
                   properly and got shorter animation.
                    </li>
                    <li className="li-pf"> 
                    Toy car voucher now is immediatelly dropped by the first
                    Car and the enemy itself can drop lockets now.
                       </li>
                    </ul>
                    <h2 className='white'>
                      Balance Changes
                    </h2>
                    <ul className='white'>
                      <li className="li-pf"> 
                        Dungeon entries are a lot cheaper now.
                          </li>
                          <li className="li-pf"> 
                              Casual toys take less damage from area attacks
                              now.
                                </li>
                          </ul>
           <hr/>
          <h1 className='white'>
              Version 1.16 Final-Mix
           </h1>
           <h2 className='white'>
              Design Changes
            </h2>
            <ul className='white'>
                <li className="li-pf"> 
                   Sonia's abilities "Dark Sacrifice" and
                   "Monster from Overworld" deal visible
                   damage now
                    </li>
                    </ul>
                    <h2 className='white'>
                      Balance Changes
                    </h2>
                    <ul className='white'>
                      <li className="li-pf"> 
                        Dark Sacrifice deals double amount of damage from
                        before.
                          </li>
                          </ul>
           <hr/>
          <h1 className='white'>
              Version 1.15 Final-Mix
           </h1>
           <h2 className='white'>
              Balance Changes
            </h2>
            <ul className='white'>
               <li className="li-pf"> 
                Rattle Blow costs 90 MANA now, instead of 120
               </li>
               <li className="li-pf"> 
                  Rain of Chunks is 200 MANA now, instead of 100 and
                  is achievable later than before
                 </li>
                 <li className="li-pf"> 
                  Select Toy is 250 MANA now, instead of 350
                 </li>
                 <li className="li-pf"> 
                 Car Race increases SPEED even more for first
                 2 turns after being used.
                 </li>
              
           </ul>
           <h2 className='white'>
            Design Changes
          </h2>
          <ul className='white'>
              <li className="li-pf"> 
                 There are pop-ups appearing on dealing damage,
                 healing effects and state gaining or losing.
                  </li>
            <li className="li-pf"> 
              New slider dungeons has been added to the
              Killergarten location, locked at first, but
              possible to be entered after collecting
              enough of new item "locket" that has
              chance of dropping from casual enemies.
      
              Each dungeon got waves of enemies in rooms
              which after being beaten, you are able to move
              forward in the dungeon until the final battle.
      
              After defeating final dungeon fight, you'll be
              rewarded with password ticket holding a code.
            </li>
            <li className="li-pf"> 
            Added new item "Password Reader"
            that allows to give rewards in exchange
            for passwords from the tickets
            </li>
            <li className="li-pf"> 
              NEW BIG CHALLENGE HAS BEEN ADDED TO THE GAME
              THAT CAN BE REVEALED ONLY AFTER DEALING WITH
              MOST OF THE DUNGEONS.
              </li>
           
         </ul>
          <hr/>
          <h1 className='white'>
              Version 1.14
           </h1>
           <h2 className='white'>
              Bug Fixes
          </h2>
          <ul className='white'>
             <li className="li-pf"> There is no more missing ost from secret parts
             </li>
            
         </ul>
           <h2 className='white'>
              Balance Changes
            </h2>
            <ul className='white'>
               <li className="li-pf"> 
                 Play with cars is 45 Mana now, was 80
               </li>
               <li className="li-pf"> 
                  Car race is 100 Mana now, was 245
                </li>
                <li className="li-pf"> 
                  Rattlatui is 45 Mana now, was 100
                </li>   
                <li className="li-pf"> 
                  Rattle Party is 435 Mana now, was 500
                </li>  
                <li className="li-pf"> 
                  Tryhard Combo now needs usual combos usage
                  to gain strenght and isn't as strong as
                  before
                </li>   
                <li className="li-pf"> 
                  Using toys now restore 10 Mana to All
                  party members
                </li>
                <li className="li-pf"> 
                Carpet costs now 25, was 50
                </li>  
           </ul>
           <h2 className='white'>
            Design Changes
          </h2>
          <ul className='white'>
            <li className="li-pf"> 
              After beating Shanty bosses you will receive prismatic star,
              if you manage to beat them in a video, you'll be rewarded
              in far future project...
            </li>
            <li>
               Battle result page has been added which shows
               after winning a battle
            </li>
            <li>
             You can select between dark or bright interface now
           </li>
           <li>
           Combo unlock pictures now display after beating combo bosses
            </li>
         </ul>
          <hr/>
          <h1 className='white'>
              Version 1.13
           </h1>
           <h2 className='white'>
              Bug Fixes
          </h2>
          <ul className='white'>
             <li className="li-pf"> Stach or Janita won't cause any game 
                 stopping problems now
             </li>
            
         </ul>
           <h2 className='white'>
              Balance Changes
            </h2>
            <ul className='white'>
               <li className="li-pf"> 
                 Capcake's Select a Toy deals damage at the top of generating toys now
               </li>
               <li className="li-pf"> 
                Box of toys increases Capcake's DEF, ATK and SPEED in top of
                generating toys now
                </li>
           </ul>
           <h2 className='white'>
            Design Changes
          </h2>
          <ul className='white'>
            <li className="li-pf"> 
              Checkpoint passwords now are added to the game, inputing them at
              the page might give you saves from the parts of the game
              you've reached.
            </li>
            <li>
                Killergarten questlog is added to the game showing
                what to do at the place. (Not necessary, rather
                for beginners Compatible fully only with newly started game)
            </li>
         </ul>
          <hr/>
          <h1 className='white'>
              Version 1.12
           </h1>
          <h2 className='white'>
            Balance Changes
          </h2>
          <ul className='white'>
             <li className="li-pf"> 
                One of the bossrush bosses lost 2 of his OP multiple strike abilities.
             </li>
            
         </ul>
         <h2 className='white'>
          Design Changes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
           1.5 star camera, 2 star camera,
           3 star camera, 4 star camera and
           5 star camera have their brand new battler graphics
          </li>
       </ul>
       <hr/>
          <h1 className='white'>
              Version 1.11
           </h1>
          <h2 className='white'>
            Balance Changes
          </h2>
          <ul className='white'>
             <li className="li-pf"> 
                Chain of chunks now deals damage on top of generating toys.
             </li>
             <li className="li-pf"> 
              High DEF Five now buffs whole party.
          </li>
        
            
         </ul>
         <h2 className='white'>
          Design Changes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
           The skill menu panes have more visible background. 
          </li>
       </ul>
       <hr/>
          <h1 className='white'>
              Version 1.10
           </h1>
           <h2 className='white'>
               Bug Fixes
           </h2>
           <ul className='white'>
              <li className="li-pf"> Fatbob's requirements have proper images now.</li>
             
          </ul>
          <h2 className='white'>
            Balance Changes
          </h2>
          <ul className='white'>
             <li className="li-pf"> 
                 One of the basement bosses lost it's OP triple strike move.
             </li>
             <li className="li-pf"> 
            Some party member items need less turns to charge now.
          </li>
        
            
         </ul>
         <h2 className='white'>
          Design Changes
        </h2>
        <ul className='white'>
          <li className="li-pf"> Recruitable characters now
              have their party join pictures.
          </li>
          <li className="li-pf"> Shopkeepers and automatons now have
              their graphics.
          </li>
          <li className="li-pf"> Skill display is now animated.
          </li>
          <li className="li-pf"> Character equipment is prettier now.
          </li>
         
      </ul>
          <hr/>
          <h1 className='white'>
              Version 1.07
           </h1>
           <h2 className='white'>
               Bug Fixes
           </h2>
           <ul className='white'>
              <li className="li-pf"> Palace final boss #2 now works properly</li>
             
          </ul>
          <h2 className='white'>
            Balance Changes
          </h2>
          <ul className='white'>
             <li className="li-pf"> Each ghost gatling scythe now needs 2
                 souls instead of four.
             </li>
             <li className="li-pf"> Doom of Afterlife needs 10 souls
                 instead of 30 now.
          </li>
          <li className="li-pf"> Breakdown costs 45 TP instead of 30
              now.
       </li>
       <li className="li-pf"> Chances for both Nap token and pack of tokens are
           increased from 1/33 to 1/20.
      </li>
            
         </ul>
         <h2 className='white'>
          Design Changes
        </h2>
        <ul className='white'>
          <li className="li-pf"> Sonia's Curation and Soul Curation animation
              is a lot shorter now.
          </li>
         
      </ul>
          <hr/>
          <h1 className='white'>
             Version 1.06
          </h1>
          <h2 className='white'>
              Bug Fixes
          </h2>
          <ul className='white'>
              <li className="li-pf"> FatBob requirements now works properly</li>
             
          </ul>
          <h2 className='white'>
              Balance Changes
          </h2>
          <ul className='white'>
              <li className="li-pf"> Every common enemy drops x1.5 more gold now</li>
              <li className="li-pf" > Chance for Nap tokens is 1/33 instead of 1/50</li>
              <li className="li-pf" > Corridor camera is easier now.
              </li>
              <li className="li-pf" > There are some chests in the gym now.
              </li>
          </ul>
          <h2 className='white'>
              New additions
          </h2>
          <ul className='white'>
          
              <li className="li-pf" > New droppable item has been added to the game called "pack of tokens" which
                  gives 50 - 200 tokens upon use and have 1/33 chance of dropping from common toys.
              </li>
              <li className="li-pf" >
                 Fist shop advices you to buy the most crucial item in the early game "carpet" now.
                  </li>
              <li className="li-pf" >
              Ways to side rooms from both of left and right corridor are more visible now.
              </li>
          </ul>
      </div>;
    break;
    case 2:
        data = <div className={styles.newsChanges} >
        <h1 className='white'>
          Version 2.987 Divided Fate
       </h1>
       <h2 className='white'>
        Design Changes
        </h2>
        <ul className='white'>
          <li className="li-pf">
            added more atmosphere
            </li>
            <li className="li-pf">
              saves display bigger picture of playable character
              </li>
              <li className="li-pf">
                bigger screen + aesthetic frame
                </li>
          </ul>
        <hr/>
        <h1 className='white'>
          Version 2.986 Divided Fate
       </h1>
       <h2 className='white'>
        Bug Fixes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
          Minor Bug Fixes
            </li>
        </ul>
     <hr/>
        <h1 className='white'>
          Version 2.985 Divided Fate
       </h1>
       <h2 className='white'>
        Bug Fixes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
          Minor Bug Fixes
            </li>
        </ul>
     <hr/>
        <h1 className='white'>
          Version 2.98 Divided Fate
       </h1>
       <h2 className='white'>
        Bug Fixes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
           Kucyki's acronical excursion skill is fixed
            </li>
        </ul>
     <hr/>
       <h2 className='white'>
        Bug Fixes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
           Kucyki's attack is fixed now
            </li>
        </ul>
     <hr/>
        <h1 className='white'>
          Version 2.96 Divided Fate
       </h1>
       <h2 className='white'>
        Bug Fixes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
           Dziowak should be defeated after taking 3 hits in his third phase now
            </li>
        </ul>
     <hr/>
        <h1 className='white'>
          Version 2.95 Divided Fate
       </h1>
        <h2 className='white'>
          Bug Fixes
          </h2>
          <ul className='white'>
            <li className="li-pf"> 
             5th Serials quest works properly now
              </li>
          </ul>
       <hr/>
        <h1 className='white'>
          Version 2.9 Divided Fate
       </h1>
        <h2 className='white'>
          Design Changes
          </h2>
          <ul className='white'>
            <li className="li-pf"> 
             Some of Poof's active skills are transformed into passives
              </li>
              <li className="li-pf"> 
               Lockpick plays animation after success now
                 </li>
                 <li className="li-pf"> 
                  Jumping Ball and Buffa Rodeo are stronger now
                    </li>
          </ul>
       <hr/>
        <h1 className='white'>
          Version 2.7 Divided Fate
       </h1>
       <h2 className='white'>
        Bug Fixes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
           Demon moves properly and attacks bosses now
            </li>
        </ul>
        <h2 className='white'>
          Design Changes
          </h2>
          <ul className='white'>
            <li className="li-pf"> 
             Capcake's skills that generates Toys by use
             are now passive abilities.
             </li>
             <li className="li-pf"> 
              Majones's skills got buffed.
              </li>
              <li className="li-pf"> 
               Flop deals damage to larger are now
               and his growth mechanic got changed
                </li>
            </ul>
       <hr/>
        <h1 className='white'>
          Version 2.5 Divided Fate
       </h1>
       <h2 className='white'>
        Bug Fixes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
           Kappa Fight got Entirely Fixed
            </li>
        </ul>
       <hr/>
        <h1 className='white'>
          Version 2.4 Divided Fate
       </h1>
       <h2 className='white'>
        Bug Fixes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
            Some bugs got fixed
            </li>
        </ul>
       <hr/>
        <h1 className='white'>
          Version 2.35 Divided Fate
       </h1>
       <h2 className='white'>
        Bug Fixes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
            Lord Fboy encounter now unlocks things properly
            ???
            </li>
        </ul>
        
       <hr/>
        <h1 className='white'>
          Version 2.3 Divided Fate
       </h1>
       <h2 className='white'>
        Bug Fixes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
            hud disappearing bug got fixed
            </li>
        </ul>
       <hr/>
        <h1 className='white'>
          Version 2.2 Divided Fate
       </h1>
       <h2 className='white'>
        Design Changes
        </h2>
        <ul className='white'>
          <li className="li-pf"> 
           Combos have visual appearance on the hud now
           </li>
          <li className="li-pf"> 
            Checklist appears in the menu now
           </li>
           <li className="li-pf"> 
            On Divided Fate floors you'll receive 1HP UP per floor
           </li>
           <li className="li-pf"> 
            Chocolate bar icon appears after use
            and lasts longer now
           </li>
           <li className="li-pf"> 
           MP bar is horizontal now
           </li>
           <li className="li-pf"> 
            Optimise option and Clear option got removed, same with Sell option from the shop
            </li>
            <li className="li-pf"> 
              Ending the game works same as Quicksaving now
              </li>
              <li className="li-pf"> 
               Game Font got changed to Verdana
                </li>
              </ul>
       <h2 className='white'>
       Bug Fixes
       </h2>
       <ul className='white'>
        <li className="li-pf"> 
          Random character unlocks no longer occur
            </li>
            <li className="li-pf"> 
              WOV bosses don't hide item/skill Hud now
                </li>
                <li className="li-pf"> 
                 Portal to Eggverse doesn't appear at Divided Site now
                    </li>
                    <li className="li-pf"> 
                      Teabat's quest works properly now
                         </li>
                         <li className="li-pf"> 
                          Attack don't stop on crowded enemy groups now
                             </li>
                             <li className="li-pf"> 
                              Bookclub Library can't spawn on starting room
                                 </li>
                               
            </ul>
       <hr/>
          <h1 className='white'>
              Version 2.0 Divided Fate
           </h1>
          
           <h2 className='white'>
             DLC - Game Changes
            </h2>
            <ul className='white'>
              <li className="li-pf"> 
                Added New Floors
                  </li>
                  <li className="li-pf"> 
                    New Generation System
                        </li>
                        <li className="li-pf"> 
                         Added New Foes
                              </li>
                              <li className="li-pf"> 
                                  Added New Items
                                       </li>
                                       <li className="li-pf"> 
                                          Added New Bosses
                                               </li>
                                               <li className="li-pf"> 
                                                  Added New Characters
                                                       </li>
                                                       <li className="li-pf"> 
                                                          Added New Endings
                                                               </li>
                                                               <li className="li-pf"> 
                                                                  Added New Mechanics
                                                                       </li>
                                                                       <li className="li-pf"> 
                                                                          Added New Lore
                                                                               </li>
                  </ul>
                  <hr/>
          <h1 className='white'>
              Version 1.1
           </h1>
           <h2 className='white'>
             Design Changes
            </h2>
            <ul className='white'>
              <li className="li-pf"> 
                Quicksave option has been added to
                the game
                  </li>
                  <li className="li-pf"> 
                     Sonia by consuming pizzas gains MP instead
                     of HP
                        </li>
                        <li className="li-pf"> 
                          Some elements and visuals got changed
                             </li>
                             <li className="li-pf"> 
                              Easy mode increases stats and gives
                              additional items on start
                                 </li>
                  </ul>
          <h1 className='white'>
              Version 1.04
           </h1>
           <h2 className='white'>
              Bug Fixes
            </h2>
            <ul className='white'>
              <li className="li-pf"> 
                Game starting glitch is fixed now.
                  </li>
                  </ul>
          <h1 className='white'>
              Version 1.03
           </h1>
           <h2 className='white'>
              Bug Fixes
            </h2>
            <ul className='white'>
              <li className="li-pf"> 
                Final world progression has been fixed.
                  </li>
                  </ul>
                  <h2 className='white'>
                      Balance Changes
                    </h2>
                   <ul className='white'>
                      <li className="li-pf"> 
                        Sonia has now 50% chance to fire her
                        attack further than usual every attack
                          </li>
                          <li className="li-pf"> 
                              Tealena's Cup of Tea passive, restores
                              1 heart instead of giving whole HP container
                              now.
                                </li>
                          </ul>
          <h1 className='white'>
              Version 1.02
           </h1>
          
           <h2 className='white'>
              Bug Fixes
            </h2>
            <ul className='white'>
              <li className="li-pf"> 
                Final world cabin appearance is fixed
                  </li>
                  </ul>
                  <hr/>
          <h1 className='white'>
              Version 1.01
           </h1>
           <h2 className='white'>
              Balance Changes
            </h2>
            <ul className='white'>
              <li className="li-pf"> 
                Capcake's attack explode at the end
                of shot now
                  </li>
                  <li className="li-pf"> 
                     Capcake's attacks are faster now
                        </li>
                        <li className="li-pf"> 
                          Purple chunks take very short breaks
                          between moving now.
                             </li>
                             <li className="li-pf"> 
                          Sonia's Curation is 2 MP now
                       
                                 </li>
                                 <li className="li-pf"> 
                                 
                                  Sonia's Revive is 3 MP now
                                         </li>
                                         <li className="li-pf"> 
                                 
                                          Sonia now starts with additional empty
                                          heart container
                                                 </li>
                                                 <li className="li-pf"> 
                                 
                                                  Sonia's HIT RATE is higher by 1 point now.
                                                         </li>
                  </ul>
                  <hr/>
      </div>;
    break;
    case 3:
        data = <div className={styles.newsChanges}>
          <h1 className='white'>
            Re|Time Demo is Out!
         </h1>
         <h2 className='white'>
           Try new battle mechanics and improved old features!
        </h2>
        
            <hr/>

              <h1 className='white'>
            Version 1.16 Halloween
         </h1>
         <h2 className='white'>
           What's new
        </h2>
        <ul className='white'>
        <li className="li-pf"> 
               Halloween Event Started!!
            </li>
            </ul>
         <h2 className='white'>
            Design Changes
        </h2>
        <ul className='white'>
            <li className="li-pf"> 
               Sonia got souls displayed at character face
            </li>
            <li className="li-pf"> 
               Tealena got wheel displayed at character face
            </li>
            <li className="li-pf"> 
               Capcake got chunks
            </li>
            <li className="li-pf"> 
               Cubus got fists displayed at character face
            </li>
            <li className="li-pf"> 
               Kucyki got glonies displayed at character face
            </li>
            </ul>
            <hr/>
            <h1 className='white'>
            Version 1.14
         </h1>
         <h2 className='white'>
            Design Changes
        </h2>
         <ul className='white'>
            <li className="li-pf"> 
                Added More atomsphere
            </li>
            <li className="li-pf"> 
                Enemies in battle have animation now
            </li>
            <li className="li-pf"> 
               Game screen is bigger now
            </li>
         </ul>
         <hr/>
        <h1 className='white'>
            Version 1.13
         </h1>
         <ul className='white'>
            <li className="li-pf"> 
                Minor Bug Fixes
            </li>
         </ul>
         <hr/>
        <h1 className='white'>
            Version 1.12
         </h1>
         <ul className='white'>
            <li className="li-pf"> 
                Minor Bug Fixes
            </li>
         </ul>
         <hr/>
        <h1 className='white'>
            Version 1.10
         </h1>
         <h2 className='white'>
            Design Changes
        </h2>
         <ul className='white'>
            <li className="li-pf"> 
                 Cubus now doesn't display MP
                            </li>
                            <li className="li-pf"> 
                         Majones Tokens got added as a game mechanic
                                        </li>
                                        <li className="li-pf"> 
                                            Majones got rebalanced
                                                           </li>
                                                        <li className="li-pf"> 
                                                            Few Kucyki's skills got balanced
                                                                           </li>
                                                                         <li className="li-pf"> 
                                                                            There's new music in the game
                                                                                           </li>
                </ul>
         <hr/>
        <h1 className='white'>
            Version 1.06
         </h1>
         <h2 className='white'>
            Bug Fixes
        </h2>
        <ul className='white'>
            <li className="li-pf"> 
                Bug revolving around game over screen
                got fixed.
             </li>
                     
                </ul>
         <hr/>
        <h1 className='white'>
            Version 1.05
         </h1>
         <h2 className='white'>
            Design Changes
        </h2>
        <ul className='white'>
            <li className="li-pf"> 
                    Autosave option now exist in the game.
                            </li>
                            <li className="li-pf"> 
                                Some unecessary options got removed from
                                battle menu.
                                        </li>
                </ul>
                <h2 className='white'>
                    Balance Changes
                </h2>
                <ul className='white'>
                    <li className="li-pf"> 
                   Cubus's Passion skill restores 100 TP now
                    </li>
                    <li className="li-pf"> 
                        Cubus's Breaktime skill gives additional punch now.
                         </li>    
                         <li className="li-pf"> 
                            Some bosses got weakened
                             </li>   
                             <li className="li-pf"> 
                                Undertable section one enemies give better
                                loot and are easier to grind on.
                                 </li>  
                        </ul>
                        <h2 className='white'>
                            Bug Fixes
                        </h2>
                        <ul className='white'>
                            <li className="li-pf"> 
                                Major bugs got fixed
                             </li>
                                     
                                </ul>
                <hr/>
                <h1 className='white'>
                    Version 1.04
                 </h1>
               
        <ul className='white'>
            <li className="li-pf"> 
              Leordean appears now at Pizzeria
              and T-City where you can move through those 
              locations freely.
                            </li>
                            <li className="li-pf"> 
                            Obtaining ??? items and serials membership can be
                            done by special passwords.
                                              </li>
                </ul>
         <h2 className='white'>
            Balance Changes
        </h2>
            <ul className='white'>
                <li className="li-pf"> 
                    Kucyki can now dual wield
                    and receives x1.5 more EXP
                                </li>
                    </ul>
         <hr/>
        <h1 className='white'>
            Version 1.03
         </h1>
            <h2 className='white'>
                Bug Fixes
            </h2>
                <ul className='white'>
                    <li className="li-pf"> 
                        Game crashing should not longer
                        happen.
                                    </li>
                        </ul>
                          <hr/>
        <h1 className='white'>
            Version 1.02
         </h1>
         <h2 className='white'>
            Balance Changes
          </h2>
          <ul className='white'>
            <li className="li-pf"> 
            Sonia, Cubus, Gyren and Papercraft are easier now
                </li>
                <li className="li-pf"> 
                 Secret bosses have increased chance to perform
                 another move now.
                      </li>
                    
                          
                </ul>
                <h2 className='white'>
                    Design Changes
                  </h2>
                  <ul className='white'>
                    <li className="li-pf"> 
                        Required toy car battle got removed from garden's entrance
                                </li>
                      </ul>
                      <h2 className='white'>
                        Bug Fixes
                      </h2>
                      <ul className='white'>
                        <li className="li-pf"> 
                          Enemypedia got removed from the game, hopefully
                          lowering it's chance of crashing.
                                    </li>
                        </ul>
                          <hr/>
        <h1 className='white'>
            Version 1.01
         </h1>
         <h2 className='white'>
            Balance Changes
          </h2>
          <ul className='white'>
            <li className="li-pf"> 
              Gyren reacts now only in case
              of running
                </li>
                <li className="li-pf"> 
                    Lanet's Lightning damage
                    area skill deals proper damage now
                      </li>
                      <li className="li-pf"> 
                        Sonia's Devolution lasts shorter and is weaker now.
                          </li>
                          <li className="li-pf"> 
                           Goatiel is weaker now.
                              </li>
                              <li className="li-pf"> 
                                Pizzeria Bosses and TTF's are stronger now.
                                   </li>
                                   <li className="li-pf"> 
                                    Divided fate chapter got less enemies staying in the way.
                                       </li>
                                       <li className="li-pf"> 
                                     Those skills have cooldown now:
                                     - Rising Phoenix
                                     - Carousell Spin
                                     - Chunksaw 
                                           </li>
                </ul>
                </div>;
    break;
    case 4:
        data =  <div className={styles.newsChanges}>
       
          <h1 className='white'>
              Snapshot 0.123456
           </h1>
           <h2 className='white'>
              New Features
            </h2>
            <ul className='white'>
              <li className="li-pf"> 
                World of Vampirim expands it's initial content, be ready to face it heroes!!
                  </li>
                  </ul>
                  <hr/>
                 <h1 className='white'>
              Version 1.01
           </h1>
           <h2 className='white'>
              Balance Changes
            </h2>
            <ul className='white'>
              <li className="li-pf"> 
                Weapons drop more frequent
                  </li>
                  </ul>
                  <hr/>
             </div>;
    break;
    case 5:
        data =  <div className={styles.newsChanges}>
   
   <ul className='white'>
     <li className="li-pf"> 
       No changes were made.
         </li>
         </ul>
         <hr/>
    </div>;
    break;
    case 6:
      data =  <div className={styles.newsChanges}>
            
 <ul className='white'>
   <li className="li-pf"> 
     No changes were made.
       </li>
       </ul>
       <hr/>
  </div>;
  break;
  case 7:
    data =  <div className={styles.newsChanges}>
    <h1 className='white'>
 Version 1.01
</h1>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Gas Cauldrons are synchronised now.
     </li>
     </ul>
     <hr/>
     <h1 className='white'>
 Version 1.02
</h1>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   No more sliding from platforms.
     </li>
     </ul>
     <hr/>
</div>;
break;
    case 8:
        data =  <div className={styles.newsChanges}>

           <h1 className='white'>
 New DLC available for Purchase!!!
</h1>
<h2 className='white'>
 Design Updates
</h2>
<ul className='white'>
 <li className="li-pf"> 
   New UI for all Menus
     </li>
      <li className="li-pf"> 
   New UI for Option Bars
     </li>
         <li className="li-pf"> 
   Choose a skill when leveling yourself!
     </li>
     
     </ul>

     <h2 className='white'>
 New Content
</h2>
<ul className='white'>
 <li className="li-pf"> 
   3 New Major Locations!
     </li>
      <li className="li-pf"> 
   Multiple new enemies!!!
     </li>
         <li className="li-pf"> 
   Lots of Items and Minigames!
     </li>
     
     </ul>
     <hr/>

           <h1 className='white'>
 New Patch!!
</h1>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Party align with your "Main" character as leader.
     </li>
      <li className="li-pf"> 
   Clown Jo Jo no longer can obtain his ending via mashing street killer's dead body.
     </li>
         <li className="li-pf"> 
   Other minor fixes.
     </li>
     
     </ul>
     <hr/>
           
          <h1 className='white'>
 New Patch!!
</h1>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Apparition in the alleys doesn't insta kill anyomore.
     </li>
      <li className="li-pf"> 
   Farmland location doesn't lag anymore.
     </li>
         <li className="li-pf"> 
   Other small changes.
     </li>
     
     </ul>
     <hr/>
          <h1 className='white'>
 New Patch!!
</h1>
<h2 className='white'>
 Changes
</h2>
<ul className='white'>
  <li className="li-pf"> 
   Masks can be reclaimed from the wall after they've been placed in wrong order.
     </li>
 <li className="li-pf"> 
   Masks don't disappear after leaving theatre.
     </li>

     </ul>
     <hr/>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Holy arc now drops correctly.
     </li>
      <li className="li-pf"> 
   Secret Lab closes permanently after defeating Professor.
     </li>
         <li className="li-pf"> 
   Some typography fixed here and there.
     </li>
     
     </ul>
     <hr/>

          <h1 className='white'>
 New Patch!!
</h1>
<h2 className='white'>
 Changes
</h2>
<ul className='white'>
    <li className="li-pf"> 
   New interface of timing based attack.
     </li>
  <li className="li-pf"> 
   Items cost lower prices based on their durability.
     </li>
 <li className="li-pf"> 
   Every major boss now drops unique item.
     </li>
 <li className="li-pf"> 
  Srub-I can be found in the sour location now.
     </li>
      <li className="li-pf"> 
  Sleeping bags failed cardflip, deal a lot of damage instead of killing you.
     </li>
           <li className="li-pf"> 
Notes and evidence progress is stored at home.
     </li>
             <li className="li-pf"> 
Srudlaty's gang members have their use at home.
     </li>
     </ul>
     <hr/>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Srudlaty's craft ability doesn't stop working when upgrading items from bottom of the list.
     </li>
      <li className="li-pf"> 
   Some other enemy and map related bugs were fixed.
     </li>
         
     </ul>
     <hr/>

    <h1 className='white'>
 New Patch!!
</h1>
<h2 className='white'>
 Changes
</h2>
<ul className='white'>
  <li className="li-pf"> 
   Damage indicators aligned with fontstyle.
     </li>
 <li className="li-pf"> 
   Some noises got reduced.
     </li>
 <li className="li-pf"> 
  Stamina recharge speed got increased but recharges slowly after fight.
     </li>
     </ul>
     <hr/>
<h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Estate Killer doesn't hold you infinitely after losing to him.
     </li>
      <li className="li-pf"> 
   Ghosts appear at graveyard at 2 o'clock.
     </li>
         <li className="li-pf"> 
   Missing loading picture added.
     </li>
      <li className="li-pf"> 
   Softlocking store got locked for good.
     </li>
     </ul>
     <hr/>
  
</div>;
    break;
        case 9:
        data =  <div className={styles.newsChanges}>
   
   <ul className='white'>
     <li className="li-pf"> 
       No changes were made.
         </li>
         </ul>
         <hr/>
    </div>;
    break;
    case 10:
        data =  <div className={styles.newsChanges}>
   <h1 className='white'>
 DEMO VERSION AVAILABLE!!!
</h1>
<h2 className='white'>
 New Content
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Chapter II early version
     </li>
      <li className="li-pf"> 
   Sexualities and Gender mechanics
     </li>
         <li className="li-pf"> 
   It got way darker, beware of the crimson.
     </li>
     
     </ul>

     <h2 className='white'>
 Bug Fixes
</h2>
<ul className='white'>

  <li className="li-pf"> 
   Transition between Chapter I and Chapter II got unlocked with ALL the characters!!!
     </li>
 <li className="li-pf"> 
   Death animation gets back to normal after resurrecting ally.
     </li>
      <li className="li-pf"> 
   Scaling of damaged senses got fixed.
     </li>
         <li className="li-pf"> 
   Ashicny's defense mechanic got fixed.
     </li>
     
     </ul>


     <h2 className='white'>
 Design Changes
</h2>
<ul className='white'>
 <li className="li-pf"> 
   Equal rule pawnflip shows one card face-up.
     </li>
      <li className="li-pf"> 
   There are spots where you can restore Skill Sources for limited uses.
     </li>
         <li className="li-pf"> 
    You can switch between STORY/NORMAL mode now disabling/enabling battles.
     </li>
     
     </ul>

     <hr/>
           
    </div>;
    break;

  }
  setModal(<div className={`${styles.versionHistory}`}>{data}</div>);
  
}
const closeModal = () => {
  setModal(null);
}
    return (
        <div className={`${styles.gamePane}`}>
            
            <div className={`${styles.blackout}`}></div>
            <Link to={"/games"} style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top:'0%',
                left:'0%'
            }}>           
            </Link>
            <div className={`${styles.gamePaneMain} ${styles.backgroundColorDark} ${props.xmas && styles['backgroundColorDark--xmas']} ${props.halloween && styles['backgroundColorDark--halloween']}`}>
                    <div className={`${styles.gamePaneIcon}`}
                        style={{
                background: `url("/pictures/icons/${props.gameData.icon}.png") center/90% no-repeat`,
                backgroundColor: `rgba(0, 0, 0, 0.7)`
            }}></div>
                    <div className={`${styles.gamePaneTitle} ${props.xmas && styles['gamePaneTitle--xmas']} ${props.halloween && styles['gamePaneTitle--halloween']}`}>{props.gameData.name}</div>
            <div className={`${styles.gamePaneMainContainer} ${props.xmas && styles['gamePaneMainContainer--xmas']} ${props.halloween && styles['gamePaneMainContainer--halloween']}`}>
                <div className={`${styles.gamePaneContainer1} ${props.xmas && styles['gamePaneContainer1--xmas']} ${props.halloween && styles['gamePaneContainer1--halloween']}`}>
                    <div className={`${styles.gamePaneBackground}`}  style={{
                background: `url("/pictures/backgrounds/${props.gameData.id == 10 ? 'ksbackground' : props.gameData.background}.png") center/100% no-repeat`
            }}>
                       <div className={`${styles.blackout}`}></div>
                         <img className={`${styles.gamePaneCharacter}`} src={`/pictures/characters/${props.gameData.character}.png`} ></img>
                         <div className={`${styles.gamePaneMainDesc} ${props.xmas && styles['gamePaneMainDesc--xmas']} ${props.halloween && styles['gamePaneMainDesc--halloween']}`}>{props.gameData.description}</div>
                    </div>
                          <div className={`${styles.gamePaneDifficulty} ${props.xmas && styles['gamePaneDifficulty--xmas']} ${props.halloween && styles['gamePaneDifficulty--halloween']}`}>
                                  <div className={`${styles.gamePaneDifficultyTitle} ${props.xmas && styles['gamePaneDifficultyTitle--xmas']} ${props.halloween && styles['gamePaneDifficultyTitle--halloween']}`}>difficulty:</div>
                                        <div className={`${styles.gamePaneDifficultyBar} ${props.xmas && styles['gamePaneDifficultyBar--xmas']} ${props.halloween && styles['gamePaneDifficultyBar--halloween']}`}>
                                             {difficultyStars}
                                        </div>
                          </div>

                          { purchaseIds.includes(props.gameData.id) == false && props.gameData.id != 5 && <Button halloween={props.halloween} xmas={props.xmas} click={downloadGame} size={"large"}>Download</Button>} {(props.gameData.isBrowser || props.gameData.id == 5) && <Link to={`/playing/:${props.gameData.id}`}><Button halloween={props.halloween} xmas={props.xmas} click={playGame} size={"large"}>Play in browser</Button></Link>}
                        {purchaseIds.includes(props.gameData.id) && <Link target={"_blank"} to={gameLinks[props.gameData.id - 1]}><Button halloween={props.halloween} xmas={props.xmas} size={"large"}>BUY GAME</Button></Link>}
                </div>
                     <div className={`${styles.gamePaneContainer2} ${props.xmas && styles['gamePaneContainer2--xmas']} ${props.halloween && styles['gamePaneContainer2--halloween']}`}>
                <div className={`${styles.gamePaneEmpty} ${props.xmas && styles['gamePaneEmpty--xmas']} ${props.halloween && styles['gamePaneEmpty--halloween']}`}>
                    <Slider halloween={props.halloween} xmas={props.xmas} currentIndex={sliderIndex} click={openModalDesc} set={setSliderIdx} switch={switchDesc} gameData={props.gameData}></Slider>
                </div>
                <div onClick={openModalDesc} className={`desc ${styles.gamePaneDescription} ${props.xmas && styles['gamePaneDescription--xmas']} ${props.halloween && styles['gamePaneDescription--halloween']}`}><div>{props.gameData.slideDescriptions[0]}</div></div>
                <div onClick={openModal} className={`${styles.gamePaneVersion} ${props.xmas && styles['gamePaneVersion--xmas']} ${props.halloween && styles['gamePaneVersion--halloween']}`}>VERSION</div>
                        
                     </div>
                   </div>  
            </div>
            {modal != null && <Modal halloween={props.halloween} xmas={props.xmas} click={closeModal}>{modal}</Modal>}
        </div>
    );
}


export default GamePane;